<template>
  <div class="watermark-container">
    <div v-for="n in watermarks" :key="n" class="watermark">
      <div>
        {{ userInfo.user_name }}
      </div>
      <div>
        {{ userInfo.user_id  }}
      </div>
    </div>
  </div>
</template>

<script>
 import {mapGetters} from "vuex";
export default {
  data() {
    return {
      watermarks: 300 // 水印数量，可以根据屏幕大小和需要调整
    };
  },
  computed: {
      ...mapGetters(["userInfo"]),
    },
};
</script>

<style scoped>
.watermark-container {
  position: fixed;
  top: -500px;
  left: -500px;
  right: 0;
  bottom: 0;
  z-index: 9999;
  pointer-events: none;
  opacity: 0.2; /* 水印透明度 */
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  transform: rotate(-30deg); /* 倾斜角度 */
}

.watermark {
  width: 300px;
  height: 200px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.4); /* 水印颜色 */
}
</style>